import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { getDistributorParameters } from 'src/store/actions/distributorActions';
import { formatAmount } from 'src/utils/formatAmout';
import useStyles from '../styles';

const StepOne = ({ data, handleNext }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleOptionSelect = option => {
    handleNext({ forgiveDebt: option });
    if (data.distributorModel) {
      dispatch(getDistributorParameters(data.distributorModel.id));
    }
  };

  return (
    <Box>
      <Box className={classes.container}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, marginTop: 2 }}
        >
          <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 500 }}>
            {t('EARLY_TERMINATION.TITLE_PART_ONE')}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
            {t('EARLY_TERMINATION.TITLE_PART_TWO', {
              amount: formatAmount(data.balance)
            })}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          gap={1}
          mt={1}
          sx={{
            '& .MuiPaper-root': {
              flex: 1,
              textAlign: 'flex-start',
              flexDirection: 'column',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 3
              }
            }
          }}
        >
          <Paper
            elevation={1}
            onClick={() => handleOptionSelect(true)}
            sx={{
              p: 1.5,
              textAlign: 'center',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'row',
              gap: 1,
              backgroundColor: 'rgba(76, 175, 80, 0.02)',
              boxShadow: '0 2px 8px rgba(76, 175, 80, 0.08)'
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: 2,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <CheckCircleIcon color="success" variant="filled" />
              <Typography
                margin={0}
                variant="subtitle1"
                gutterBottom
                align="left"
              >
                {t('EARLY_TERMINATION.FORGIVE_DEBT')}
              </Typography>
            </div>
          </Paper>
          <Paper
            elevation={1}
            onClick={() => handleOptionSelect(false)}
            sx={{
              p: 1.5,
              textAlign: 'center',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              gap: 1,
              backgroundColor: 'rgba(244, 67, 54, 0.02)',
              boxShadow: '0 2px 8px rgba(244, 67, 54, 0.08)'
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: 2,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <CancelIcon color="error" variant="filled" />
              <Typography
                margin={0}
                variant="subtitle1"
                gutterBottom
                align="left"
              >
                {t('EARLY_TERMINATION.NO_FORGIVE_DEBT')}
              </Typography>
            </div>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

StepOne.propTypes = {
  data: PropTypes.object,
  handleNext: PropTypes.func
};

export default StepOne;
